const isDomainMatchesRegex = (test, domainRegex) => {
  const protocols = ["http", "https"].join("|")
  const regex = new RegExp(`^(${protocols})://${domainRegex}$`)
  return !!test.match(regex)
}

const convertToRegExp = (str) => {
  // 1. escape characters used in URL origin
  // 2. convert wildcard
  return str
    .replace(/[.]/g, '\\$&') // $& means the whole matched string
    .replace(/[*]/g, '.+')
}

module.exports = {
  isAllowed: (origin) => {
    const allowedDomains = process.env.ALLOWED_DOMAINS ? process.env.ALLOWED_DOMAINS.split(",") : []
    for (let domain of allowedDomains) {
      if (isDomainMatchesRegex(origin, convertToRegExp(domain))) return true
    }
    return false
  }
}